import { useTranslations, useLocale } from 'next-intl';
import { useMemo } from 'react';
import { z } from 'zod';
import getGlobalErrorMap from './getGlobalErrorMap';
function useI18nZodErrorMap() {
  const t = useTranslations("nextjs");
  const locale = useLocale();
  const map = getGlobalErrorMap(t, locale);
  const defaults = locale === "de" ? z.locales.de() : z.locales.en();
  z.config({
    ...defaults,
    customError: map
  });
}
export default useI18nZodErrorMap;